// Promise-wrapped browser geolocation. Returns null lat/lng if the caller
// declared no fix is needed (so clock-in keeps working even without permission).

export async function getPosition({ required = false } = {}) {
  if (!required) {
    return { lat: null, lng: null, accuracy_m: null };
  }
  if (!navigator.geolocation) {
    throw new Error('Geolocation unavailable in this browser');
  }
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      pos => resolve({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
        accuracy_m: pos.coords.accuracy,
      }),
      err => reject(new Error('Location denied or unavailable: ' + err.message)),
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 },
    );
  });
}
